<template>
  <div class="custom-pl-15">
    
      <div class="row mt-3 mb-5 shadow mentee-panel-wrapper">
        <div class="col">
          <router-link :to="`/view-mentee-profile-new/${mentee.id}`" class="invisible-link-style">
          <div class="row mb-2 mt-3">
            <div class="col pl-4">
              <div class="h6 d-inline mr-2 font-weight-bold text-uppercase">{{ mentee.menteeShortName }}</div>
            </div>
            <div class="col pr-4 text-uppercase text-right" style="padding-left: 2px;" v-if="mentee.menteeRepCount == 0">
              <a class="font-weight-bold" style="color: #00acee;">
                <div>
                  {{ mentee.menteeRepCount }} Reps to Review 
                  <img class="reps_review_icon" src="@/assets/manager/reps_to_review_arrow.png" />
                </div>
              </a>
            </div>
            

            <div class="col pr-4 text-uppercase text-right" v-else>
              <a href="#" @click.prevent="openRepToReviewModal($event, mentee.id)" v-if="mentee.menteeRepCount > 0" class="font-weight-bold">
                <div v-if="mentee.menteeRepCount == 1">
                  {{ mentee.menteeRepCount }} Rep to Review 
                  <img class="reps_review_icon" src="@/assets/manager/reps_to_review_arrow.png" />
                </div>
                <div v-else>
                  {{ mentee.menteeRepCount }} Reps to Review 
                  <img class="reps_review_icon" src="@/assets/manager/reps_to_review_arrow.png" />
                </div>
              </a>
            </div>
          </div>
          </router-link>



          <div v-if="activeStep != ''">
            <div class="mt-1 mb-3 pl-3 pr-3">
              <div class="row align-items-end">
                <div class="col px-2 text-center" v-for="(pathwayStep, index) in mentee.menteePathway.mentee_pathway_steps">
                  <p class="text-uppercase mb-1 " 
                    :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
                    <span :style="activeStep == pathwayStep.id ? 'background-color: ' + mentee.menteePathway.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                  </p>
                  <div class="progress progress_pathway">
                    <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                  </div>
                </div>        
              </div>
            </div>
          </div>

          <div v-else>
            <div class="mt-1 mb-3 pl-3 pr-3">
              <div class="row align-items-end">
                <div class="col px-2 text-center" v-for="(pathwayStep, index) in mentee.menteePathway.mentee_pathway_steps">
                  <p class="text-uppercase mb-1 " 
                    :class="mentee.menteePathway.mentee_pathway.currentStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
                    <span :style="mentee.menteePathway.mentee_pathway.currentStep == pathwayStep.id ? 'background-color: ' + mentee.menteePathway.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                  </p>
                  <div class="progress progress_pathway">
                    <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                  </div>
                </div>        
              </div>
            </div>
          </div>

          <div v-if="activeStep != ''" @click.stop>
            <DashoardMenteeProgress
              :menteeId="mentee.id"
              :stepId="activeStep"
              :pathwayId="mentee.menteePathway.mentee_pathway.id"
              :type="2"
              @closeAddRep="closeAddRep"
              @repclose="repModalClose"
              ref="MenteeProgressComponent"
              >
            </DashoardMenteeProgress>
          </div>
          <div v-else-if="mentee.currentStep != ''" @click.stop>
            <DashoardMenteeProgress
              :menteeId="mentee.id"
              :stepId="mentee.currentStep"
              :pathwayId="mentee.menteePathway.mentee_pathway.id"
              :type="2"
              @closeAddRep="closeAddRep"
              ref="MenteeProgressComponent"
              >
            </DashoardMenteeProgress>
          </div>






          <router-link :to="`/view-mentee-profile-new/${mentee.id}`" class="invisible-link-style">
          <div class="pl-2" v-if="mentee.mentorsAssigned.length > 0">
            <div class="text-muted">Mentor(s)</div>
            <div>
              <ul class="list-inline">
                <li class="list-inline-item font-weight-bold" v-for="(mentor, index) in mentee.mentorsAssigned" :key="index">{{ mentor.name }}</li>
              </ul>
            </div>
          </div>
          </router-link>

        </div>
      </div>
    

        <MenteeRepsToReview
          :isModalVisible="isModalVisible"
          :menteeId="selectedMenteeId"
          ref="menteeRepsToReview"
          @closeReviewAddRep="closeAddRep"
          @close-right-panel-modal="closeRightPanelModal"
          @reduceRepCount="reduceRepCount"
        ></MenteeRepsToReview>

  </div>
</template>

<script>
import axios from 'axios';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import RightPanelModal from '@/components/manager/right_panel_modal.vue';
import MenteeRepsToReview from '@/components/manager/mentee_reps_to_review.vue';
import DashoardMenteeProgress from '@/components/manager/dashboard_mentee_progress.vue';

export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    mentee: {
      type: Object,
      default: {},
    },
    menteeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedMenteeId: 0,
      isModalVisible: false,
      showRepModal: false,
      pathwayStepsData: [],
      activeStep: '',
    }
  },
  methods: {
    moveToStep(stepId) {
      if(this.mentee.futureStep == true) {
        this.activeStep = stepId;
        this.$refs.MenteeProgressComponent.reloadStep(stepId);
      }
    },
    closeAddRep() {
      this.$emit('closeAddRep');
    },
    closeReviewAddRep() {
      this.$emit('closeAddRep');
    },
    openRepToReviewModal(event, menteeId) {
      event.preventDefault();
      event.stopPropagation();
      // this.selectedMenteeId = menteeId;
      // this.showRepModal = true;
      // this.isModalVisible = true;
      // this.$refs.rightPanelModal.show();

      this.$emit('openRepToReviewModal', menteeId);
    },
    closeRightPanelModal() {
      this.$refs.rightPanelModal.hide();
      this.showRepModal = false;
      this.isModalVisible = false;
    },
    reduceRepCount(data) {
      this.$emit('reduceRepCount', data);
    },
  },
  components: {
    RightPanelModal,
    MenteeRepsToReview,
    DashoardMenteeProgress
  },
  created() {
    
  },
}
</script>

<style scoped>
.progress_step {
  height:10px;
  margin-top: 5px;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
.invisible-link-style,
.invisible-link-style:hover,
.invisible-link-style:active,
.invisible-link-style:focus {
  color: inherit !important;
  text-decoration: none;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}
.progress_bar_100 {
  background-color: #00acee !important;
}
.reps_review_icon {
  width: 15px;
  margin-left: 4px;
  margin-top: -5px;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}
.progress_bar_100 {
  background-color: #00acee !important;
}
.reps_review_icon {
  width: 15px;
  margin-left: 4px;
  margin-top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/dashboard_mentees.vue